// Keep only one product-page accordion open at a time
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(
    ".template-product main details:not(cart-drawer-component details):not(.cart-drawer details)"
  );

  accordions.forEach((accordion) => {
    accordion.addEventListener("toggle", function () {
      if (!this.open) return;

      accordions.forEach((other) => {
        if (
          other !== this &&
          other.closest(".accordion-group") === this.closest(".accordion-group")
        ) {
          other.removeAttribute("open");
        }
      });
    });
  });
});










document.addEventListener("DOMContentLoaded", () => {
  const addonWrap = document.querySelector(".addon-swatch[data-addon-variant-id]");
  if (!addonWrap) return;

  const tinVariantId = Number(addonWrap.getAttribute("data-addon-variant-id"));
  const tinToggle = addonWrap.querySelector(".js-gift-tin-toggle, input[type='checkbox']");
  if (!tinVariantId || !tinToggle) return;

  const getHeaderSectionKey = () => {
    // DOM id includes "shopify-section-" prefix; API key does NOT.
    const header = document.querySelector('header[id^="shopify-section-"][class*="header"]');
    if (!header?.id) return null;
    return header.id.replace(/^shopify-section-/, "");
  };

  const refreshCartDrawerFromHeader = async () => {
    const sectionKey = getHeaderSectionKey();
    if (!sectionKey) return false;

    const res = await fetch(`/?sections=${encodeURIComponent(sectionKey)}`, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    if (!res.ok) return false;

    const json = await res.json();
    const html = json[sectionKey];
    if (!html) return false;

    const temp = document.createElement("div");
    temp.innerHTML = html;

    // Get the NEW cart drawer component from refreshed header HTML
    const newDrawer = temp.querySelector("cart-drawer-component");
    const currentDrawer = document.querySelector("cart-drawer-component");

    if (newDrawer && currentDrawer) {
      currentDrawer.replaceWith(newDrawer);
      return true;
    }

    return false;
  };

  const openCartDrawer = () => {
    const drawer = document.querySelector("cart-drawer-component");
    const dialog = drawer?.querySelector("dialog");
    if (dialog && typeof dialog.showModal === "function") {
      if (!dialog.open) dialog.showModal();
      return true;
    }
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (trigger) {
      trigger.click();
      return true;
    }
    return false;
  };

  document.addEventListener(
    "click",
    async (e) => {
      const btn = e.target.closest(
        'button[name="add"], button[type="submit"], .product-form__submit, [data-testid*="add"]'
      );
      if (!btn) return;
      if (!tinToggle.checked) return;

      const form = btn.closest("form");
      if (!form) return;
      if (!form.querySelector('input[name="id"]')) return;

      // Stop Savor normal flow so we don't double-add
      e.preventDefault();
      e.stopImmediatePropagation();

      const prevDisabled = btn.disabled;
      btn.disabled = true;

      try {
        // 1) Add main item using exact form payload (preserves hidden fields)
        const formData = new FormData(form);
        const resMain = await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" },
        });

        if (!resMain.ok) {
          console.error("Main add failed:", await resMain.text());
          btn.disabled = prevDisabled;
          return;
        }

        // 2) Add tin
        const resTin = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: tinVariantId, quantity: 1 }] }),
        });

        if (!resTin.ok) {
          console.error("Tin add failed:", await resTin.text());
        }

        btn.disabled = prevDisabled;

        // 3) Let cart settle a beat, then refresh drawer HTML and open it
        await new Promise((r) => setTimeout(r, 200));
        await refreshCartDrawerFromHeader();

        // 4) Open drawer (now it contains fresh cart HTML)
        openCartDrawer();
      } catch (err) {
        console.error("Gift tin script error:", err);
        btn.disabled = prevDisabled;
      }
    },
    true
  );
});


































  // BOX OF 16 DISABLE THE GIFT TIN OPTION CODE
document.addEventListener("DOMContentLoaded", () => {
  // Gift tin toggle (your checkbox)
  const tinToggle = document.querySelector(".js-gift-tin-toggle");
  const tinWrap = document.querySelector(".addon-swatch");
  if (!tinToggle || !tinWrap) return;

  // Find the "Batch of 16" quantity radio inside Savor's variant picker
  const batch16Radio = document.querySelector(
    'variant-picker input[type="radio"][value="Batch of 16"]'
  );

  // If this product doesn't have that option, do nothing
  if (!batch16Radio) return;

  const setTinEnabled = (enabled) => {
    tinToggle.disabled = !enabled;

    // Optional: add a disabled style hook on the wrapper
    tinWrap.classList.toggle("addon-swatch--disabled", !enabled);

    // If disabling, also untick it
    if (!enabled) {
      tinToggle.checked = false;
      tinToggle.dispatchEvent(new Event("change", { bubbles: true }));
    }
  };

  const updateState = () => {
    // Disable tin if Batch of 16 is selected
    const isBatch16Selected = batch16Radio.checked === true;
    setTinEnabled(!isBatch16Selected);
  };

  // Initial state
  updateState();

  // Update when customer changes quantity (listen on the variant picker)
  const variantPicker = document.querySelector("variant-picker");
  if (variantPicker) {
    variantPicker.addEventListener("change", updateState);
  }

  // Extra safety: some themes change variants without firing change on the exact input
  document.addEventListener("change", (e) => {
    if (e.target && e.target.closest("variant-picker")) updateState();
  });
});



















document.addEventListener("change", function(e){
  if (e.target && e.target.id === "GiftMessageToggle") {
    const fields = document.getElementById("GiftMessageFields");
    if (fields) fields.style.display = e.target.checked ? "block" : "none";
  }
});






(() => {
  function initGiftBlock(block) {
    if (block.dataset.giftInit === '1') return;
    block.dataset.giftInit = '1';

    const toggle = block.querySelector('.GiftMessageToggle');
    const fields = block.querySelector('.GiftMessageFields');
    const textarea = block.querySelector('.GiftMessageText');

    if (!toggle || !fields || !textarea) return;

    toggle.addEventListener('change', () => {
      const on = toggle.checked;
      fields.style.display = on ? 'block' : 'none';
      textarea.required = on;
      if (!on) textarea.value = '';
    });
  }

  async function refreshCartDrawer() {
    // Works for Dawn-like themes. If your theme uses different section names, tell me the theme name.
    const sections = ['cart-drawer', 'cart-icon-bubble'];
    const res = await fetch(`/?sections=${sections.join(',')}`, { credentials: 'same-origin' });
    if (!res.ok) return;

    const html = await res.json();

    // cart drawer
    if (html['cart-drawer']) {
      const drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
      if (drawer) {
        const doc = new DOMParser().parseFromString(html['cart-drawer'], 'text/html');
        const fresh = doc.querySelector('cart-drawer') || doc.getElementById('CartDrawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
      }
    }

    // bubble
    if (html['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        const doc = new DOMParser().parseFromString(html['cart-icon-bubble'], 'text/html');
        const fresh = doc.getElementById('cart-icon-bubble');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }
    }

    // open drawer if possible
    const drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof drawerEl.open === 'function') drawerEl.open();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  // Theme-proof interception: catch clicks on ANY submit button inside a /cart/add form
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button[type="submit"], input[type="submit"]');
    if (!btn) return;

    const form = btn.closest('form[action^="/cart/add"]');
    if (!form) return;

    const block = form.querySelector('.gift-message-block[data-gift-addon-variant-id]');
    if (!block) return; // gift not enabled for this product

    initGiftBlock(block);

    const toggle = block.querySelector('.GiftMessageToggle');
    const textarea = block.querySelector('.GiftMessageText');
    const addonId = Number(block.dataset.giftAddonVariantId);

    // only hijack if checked
    if (!toggle || !toggle.checked) return;

    console.log('[Gift] Intercept add-to-cart');

    // validate
    if (!textarea || !textarea.value.trim()) {
      e.preventDefault();
      e.stopPropagation();
      textarea && textarea.focus();
      return;
    }

    if (!addonId) {
      console.warn('[Gift] Missing addon variant id on product metafield');
      return;
    }

    // stop theme’s normal AJAX add-to-cart
    e.preventDefault();
    e.stopPropagation();

    const fd = new FormData(form);
    const mainVariantId = Number(fd.get('id'));
    const qty = Number(fd.get('quantity')) || 1;

    // collect properties from the form
    const properties = {};
    for (const [k, v] of fd.entries()) {
      const m = String(k).match(/^properties\[(.+)\]$/);
      if (m) properties[m[1]] = v;
    }

    console.log('[Gift] Main variant:', mainVariantId, 'Addon variant:', addonId, 'Qty:', qty, 'Props:', properties);

    const payload = {
      items: [
        { id: mainVariantId, quantity: qty, properties },
        { id: addonId, quantity: qty, properties: { "Gift message for": String(mainVariantId) } }
      ]
    };

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      console.error('[Gift] /cart/add.js failed');
      return;
    }

    await refreshCartDrawer();
  }, true);

  // init any blocks already on the page
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.gift-message-block[data-gift-addon-variant-id]').forEach(initGiftBlock);
  });

  // if sections reload dynamically
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll?.('.gift-message-block[data-gift-addon-variant-id]').forEach(initGiftBlock);
  });
})();

































// add price change to product page price when clickig gift message or gift tin
document.addEventListener('DOMContentLoaded', async () => {
  if (!document.body.classList.contains('template-product')) return;

  const pathHandle = window.location.pathname.split('/products/')[1]?.split('/')[0]?.split('?')[0];
  if (pathHandle !== 'the-london-cookies') return;


  const PRODUCT_HANDLE = 'the-london-cookies';
  const GIFT_MESSAGE_EXTRA = 250; // £2.50
  const GIFT_PACKAGING_EXTRA = 500; // £5.00

  const variantIdInput = document.querySelector('form[action="/cart/add"] input[name="id"]');
  const giftPackagingCheckbox = document.querySelector('.js-gift-tin-toggle');

  if (!variantIdInput) return;

  let variantPrices = {};

  try {
    const res = await fetch(`/products/${PRODUCT_HANDLE}.js`);
    const product = await res.json();

    product.variants.forEach((variant) => {
      variantPrices[String(variant.id)] = variant.price;
    });
  } catch (err) {
    console.error('Could not load product JSON:', err);
  }

  function formatMoney(pence) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(pence / 100);
  }

  function parseMoneyToPence(text) {
    const numeric = (text || '').replace(/[^\d.]/g, '');
    return Math.round(parseFloat(numeric || '0') * 100);
  }

  function getGiftMessageCheckbox() {
    return document.querySelector(
      '.avpoptions-container__v2 input[type="checkbox"][data-option-type="checkbox"][field-name="Gift Message Card"]'
    );
  }

  function getExtraPrice() {
    let extras = 0;

    const giftMessageCheckbox = getGiftMessageCheckbox();

    if (giftMessageCheckbox && giftMessageCheckbox.checked) {
      extras += GIFT_MESSAGE_EXTRA;
    }

    if (giftPackagingCheckbox && giftPackagingCheckbox.checked) {
      extras += GIFT_PACKAGING_EXTRA;
    }

    return extras;
  }

  function getPriceNodes() {
    return document.querySelectorAll([
      'product-price .price',
      '.sticky-add-to-cart__price .price',
      '[data-testid="sticky-price-display"] .price'
    ].join(', '));
  }

  function getBasePrice() {
    const variantId = String(variantIdInput.value || '');

    if (variantPrices[variantId] != null) {
      return variantPrices[variantId];
    }

    const firstPriceNode = getPriceNodes()[0];
    if (!firstPriceNode) return null;

    if (firstPriceNode.dataset.basePrice) {
      return parseInt(firstPriceNode.dataset.basePrice, 10);
    }

    return parseMoneyToPence(firstPriceNode.textContent);
  }

  function updateAllDisplayedPrices() {
    const priceNodes = getPriceNodes();
    if (!priceNodes.length) return;

    const basePrice = getBasePrice();
    if (basePrice == null || Number.isNaN(basePrice)) return;

    // Refresh stored clean base price on each update when we know the real variant price
    const variantId = String(variantIdInput.value || '');
    const realVariantPrice = variantPrices[variantId];

    priceNodes.forEach((node) => {
      if (realVariantPrice != null) {
        node.dataset.basePrice = String(realVariantPrice);
      } else if (!node.dataset.basePrice) {
        node.dataset.basePrice = String(parseMoneyToPence(node.textContent));
      }
    });

    const totalPrice = basePrice + getExtraPrice();
    const formatted = formatMoney(totalPrice);

    priceNodes.forEach((node) => {
      node.textContent = formatted;
    });
  }

  document.addEventListener('change', (event) => {
    const target = event.target;

    if (
      target.matches('.avpoptions-container__v2 input[type="checkbox"][data-option-type="checkbox"][field-name="Gift Message Card"]') ||
      target.matches('.js-gift-tin-toggle') ||
      target.matches('variant-picker input[type="radio"]')
    ) {
      setTimeout(updateAllDisplayedPrices, 100);
    }
  });

  let lastVariantId = variantIdInput.value;
  setInterval(() => {
    if (variantIdInput.value !== lastVariantId) {
      lastVariantId = variantIdInput.value;
      updateAllDisplayedPrices();
    }
  }, 200);

  setTimeout(updateAllDisplayedPrices, 300);
  setTimeout(updateAllDisplayedPrices, 800);
  setTimeout(updateAllDisplayedPrices, 1500);

  updateAllDisplayedPrices();
});


























// THIS CODE MOVES THE CHOOSE 3 FALVOURS TEXT TO BELOW THE TITLE ON THE CHOC DATES PRODUCT 
function moveHelpText() {

  document.querySelectorAll('.avp-option.ap-options__swatch-container').forEach(block => {

    const titleWrapper = block.querySelector('.ap-label-tooltip');
    const helpText = block.querySelector('.ap-helptext');

    if (titleWrapper && helpText && helpText.previousElementSibling !== titleWrapper) {
      titleWrapper.insertAdjacentElement('afterend', helpText);
    }

  });

}
setInterval(moveHelpText, 500);





























// HIDE ACCORDION ON PRODUCT PAGE IF NOT INFO ENTERED 
document.querySelectorAll('.accordion').forEach(acc => {
  const content = acc.querySelector('.details-content');
  if (!content || content.textContent.trim() === '') {
    acc.style.display = 'none';
  }
});
















//CART DRAWER SHOW HIGH PRICE ITEMS ON TOP 
document.addEventListener('DOMContentLoaded', () => {
  let sortFrame = null;
  let burstTimer = null;

  function parsePrice(text) {
    if (!text) return 0;
    return parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
  }

  function sortCartDrawerItems() {
    const tbody = document.querySelector('.cart-items__table tbody');
    if (!tbody) return false;

    const rows = Array.from(tbody.querySelectorAll(':scope > tr.cart-items__table-row'));
    if (rows.length < 2) return false;

    const currentOrder = rows.map(row => row.dataset.key || '').join('|');

    const sortedRows = [...rows].sort((a, b) => {
      const priceA = parsePrice(a.querySelector('.cart-items__price')?.textContent);
      const priceB = parsePrice(b.querySelector('.cart-items__price')?.textContent);
      return priceB - priceA;
    });

    const sortedOrder = sortedRows.map(row => row.dataset.key || '').join('|');

    if (currentOrder === sortedOrder) return true;

    sortedRows.forEach(row => tbody.appendChild(row));
    return true;
  }

  function scheduleSort() {
    cancelAnimationFrame(sortFrame);
    sortFrame = requestAnimationFrame(() => {
      sortCartDrawerItems();
    });
  }

  function startSortBurst(duration = 2000, interval = 80) {
    clearInterval(burstTimer);

    scheduleSort();

    burstTimer = setInterval(() => {
      sortCartDrawerItems();
    }, interval);

    setTimeout(() => {
      clearInterval(burstTimer);
    }, duration);
  }

  // Initial attempt
  startSortBurst(1500, 80);

  // Re-sort whenever anything in the page changes
  const bodyObserver = new MutationObserver(() => {
    scheduleSort();
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Re-sort after common cart interactions
  document.addEventListener('click', (event) => {
    if (
      event.target.closest('.cart-drawer__close-button') ||
      event.target.closest('.cart-items__remove') ||
      event.target.closest('.quantity-plus') ||
      event.target.closest('.quantity-minus') ||
      event.target.closest('[data-cart-trigger]') ||
      event.target.closest('[aria-controls*="cart"]') ||
      event.target.closest('[href*="/cart"]') ||
      event.target.closest('button[name="add"]')
    ) {
      startSortBurst(2000, 80);
    }
  });

  document.addEventListener('change', (event) => {
    if (
      event.target.closest('.cart-items__table') ||
      event.target.matches('input[name="updates[]"]')
    ) {
      startSortBurst(2000, 80);
    }
  });

  // Optional: hook into Shopify cart API calls
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);

    try {
      const url = String(args[0] || '');
      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart.js')
      ) {
        startSortBurst(2000, 80);
      }
    } catch (e) {}

    return response;
  };
});
































/* add image next to gift card tick box */
document.addEventListener('DOMContentLoaded', function () {
  const giftThumbnailUrl = 'https://cdn.shopify.com/s/files/1/0957/5720/5890/files/messagecard.png?v=1782936763';

  function addGiftCardThumbnail() {
    const giftOption = document.querySelector(
      '.avpoptions-container__v2 .ap-options__checkbox'
    );

    if (!giftOption) return;

    const label = giftOption.querySelector('label.avp-productoptioncheckwrapper');
    const title = giftOption.querySelector('.choice-list-variatnt-title');

    if (!label || !title || !title.textContent.includes('Gift Card')) return;

    if (giftOption.querySelector('.gift-card-option-thumb')) return;

    const img = document.createElement('img');
    img.src = giftThumbnailUrl;
    img.alt = 'Gift card';
    img.className = 'gift-card-option-thumb';

    giftOption.insertBefore(img, giftOption.firstChild);
    giftOption.classList.add('gift-card-option-layout');
  }

  addGiftCardThumbnail();

  const observer = new MutationObserver(addGiftCardThumbnail);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

















































(function () {
  'use strict';

  function openDeliveryCalendar(event) {
    var input = document.querySelector('#ship-date');

    if (!input) {
      return;
    }

    /*
     * Stop the phone focusing and zooming into the text input.
     * We open the Flatpickr calendar directly instead.
     */
    event.preventDefault();

    if (document.activeElement === input) {
      input.blur();
    }

    if (input._flatpickr) {
      input._flatpickr.open();
    } else {
      /*
       * Fallback in case Flare has not attached
       * Flatpickr to the input yet.
       */
      input.click();

      window.setTimeout(function () {
        input.blur();
      }, 0);
    }
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      if (
        event.target.closest(
          '#ship-date, #date-selector-wrapper'
        )
      ) {
        openDeliveryCalendar(event);
      }
    },
    {
      passive: false,
      capture: true
    }
  );

  document.addEventListener(
    'pointerdown',
    function (event) {
      if (
        event.pointerType !== 'touch' &&
        event.target.closest('#ship-date, #date-selector-wrapper')
      ) {
        openDeliveryCalendar(event);
      }
    },
    true
  );

  

  /*
   * Extra protection if the app focuses the input
   * while opening the calendar.
   */
  document.addEventListener(
    'focusin',
    function (event) {
      if (
        event.target.matches(
          '#ship-date, #flare-date-picker-block .flatpickr-input, #flare-date-picker-block .flatpickr-mobile'
        )
      ) {
        window.setTimeout(function () {
          event.target.blur();
        }, 0);
      }
    },
    true
  );
})();


























/// Code to make Flare Calendar show on Kaching Upsell Cart Bar ///

(function () {
  'use strict';

  var moveTimer;

  function moveFlareCalendar() {
    var slot = document.querySelector('#kaching-flare-calendar-slot');
    var calendar = document.querySelector('#flare-date-picker-block');

    if (!slot || !calendar) {
      return;
    }

    /*
     * Avoid moving it again if it is already
     * inside the Kaching custom HTML slot.
     */
    if (slot.contains(calendar)) {
      return;
    }

    slot.appendChild(calendar);
    calendar.classList.add('flare-calendar-in-kaching');
  }

  function scheduleMove() {
    clearTimeout(moveTimer);

    moveTimer = window.setTimeout(function () {
      moveFlareCalendar();
    }, 100);
  }

  /*
   * Kaching dynamically builds and refreshes its drawer,
   * so watch for the custom HTML placeholder appearing.
   */
  var observer = new MutationObserver(function (mutations) {
    var drawerChanged = mutations.some(function (mutation) {
      return (
        mutation.type === 'childList' &&
        (mutation.addedNodes.length || mutation.removedNodes.length)
      );
    });

    if (drawerChanged) {
      scheduleMove();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('cart:updated', scheduleMove);
  document.addEventListener('cart:refresh', scheduleMove);

  window.addEventListener('load', function () {
    window.setTimeout(moveFlareCalendar, 500);
  });

  moveFlareCalendar();
})();






























/* Kaching checkout delivery-date requirement */
(function () {
  'use strict';

  var warningTimer;
  var updateTimer;

  function getDateInput() {
    return document.querySelector(
      '#kaching-flare-calendar-slot #ship-date, #ship-date'
    );
  }

  function hasDeliveryDate() {
    var input = getDateInput();

    if (!input) {
      return false;
    }

    var inputValue = String(input.value || '').trim();
    var deliveryDate = String(
      input.getAttribute('data-delivery-date') || ''
    ).trim();

    return (
      inputValue !== '' ||
      (
        deliveryDate !== '' &&
        deliveryDate !== 'undefined' &&
        deliveryDate !== 'null'
      )
    );
  }

  function getElements() {
    var cart = document.querySelector('#kaching-cart');

    if (!cart) {
      return null;
    }

    return {
      cart: cart,
      footer: cart.querySelector('.kaching-cart__footer'),
      checkout: cart.querySelector('#kaching-cart__checkout-button'),
      payments: cart.querySelector(
        '.kaching-cart__accelerated-checkout-buttons'
      ),
      datePicker: cart.querySelector('#flare-date-picker-block') ||
        document.querySelector('#flare-date-picker-block')
    };
  }

  function setImportantStyle(element, property, value) {
    if (!element) {
      return;
    }

    if (
      element.style.getPropertyValue(property) !== value ||
      element.style.getPropertyPriority(property) !== 'important'
    ) {
      element.style.setProperty(property, value, 'important');
    }
  }

  function getWarning(elements) {
    if (!elements.datePicker) {
      return null;
    }

    var warning = elements.datePicker.querySelector(
      '.kaching-delivery-date-warning'
    );

    if (!warning) {
      warning = document.createElement('div');
      warning.className = 'kaching-delivery-date-warning';
      warning.setAttribute('role', 'alert');
      warning.setAttribute('aria-live', 'polite');
      warning.textContent =
        'Please choose a delivery date before checking out.';

      elements.datePicker.appendChild(warning);
    }

    return warning;
  }

  function showWarning() {
    var elements = getElements();

    if (!elements) {
      return;
    }

    var warning = getWarning(elements);
    var dateSelector = elements.datePicker
      ? elements.datePicker.querySelector('#date-selector-wrapper')
      : null;

    clearTimeout(warningTimer);

    if (warning) {
      warning.classList.remove('is-visible');
    }

    if (elements.checkout) {
      elements.checkout.classList.remove('kaching-delivery-shake');
    }

    if (elements.payments) {
      elements.payments.classList.remove('kaching-delivery-shake');
    }

    if (dateSelector) {
      dateSelector.classList.remove('kaching-delivery-highlight');
    }

    /*
     * Restart the animation.
     */
    if (elements.footer) {
      void elements.footer.offsetWidth;
    }

    if (warning) {
      warning.classList.add('is-visible');
    }

    if (elements.checkout) {
      elements.checkout.classList.add('kaching-delivery-shake');
    }

    if (elements.payments) {
      elements.payments.classList.add('kaching-delivery-shake');
    }

    if (dateSelector) {
      dateSelector.classList.add('kaching-delivery-highlight');
    }

    warningTimer = window.setTimeout(function () {
      if (warning) {
        warning.classList.remove('is-visible');
      }

      if (elements.checkout) {
        elements.checkout.classList.remove('kaching-delivery-shake');
      }

      if (elements.payments) {
        elements.payments.classList.remove('kaching-delivery-shake');
      }

      if (dateSelector) {
        dateSelector.classList.remove('kaching-delivery-highlight');
      }
    }, 4000);
  }

  function createPaymentCatcher(elements) {
    if (!elements.payments) {
      return;
    }

    var catcher = elements.payments.querySelector(
      '.kaching-delivery-payment-catcher'
    );

    if (catcher) {
      return;
    }

    catcher = document.createElement('div');
    catcher.className = 'kaching-delivery-payment-catcher';
    catcher.setAttribute('role', 'button');
    catcher.setAttribute('tabindex', '0');
    catcher.setAttribute(
      'aria-label',
      'Choose a delivery date before using express checkout'
    );

    catcher.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      showWarning();
    });

    catcher.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        showWarning();
      }
    });

    elements.payments.appendChild(catcher);
  }

  function removePaymentCatcher(elements) {
    if (!elements.payments) {
      return;
    }

    var catcher = elements.payments.querySelector(
      '.kaching-delivery-payment-catcher'
    );

    if (catcher) {
      catcher.remove();
    }
  }

  function updateKachingCheckout() {
    var elements = getElements();

    if (!elements || !elements.footer) {
      return;
    }

    var dateSelected = hasDeliveryDate();

    elements.cart.classList.toggle(
      'kaching-delivery-date-missing',
      !dateSelected
    );

    if (dateSelected) {
      /*
       * Override the grey styles that Flare placed
       * directly on the Kaching checkout button.
       */
      setImportantStyle(elements.checkout, 'opacity', '1');
      setImportantStyle(elements.checkout, 'pointer-events', 'auto');

      setImportantStyle(elements.payments, 'opacity', '1');
      setImportantStyle(elements.payments, 'pointer-events', 'auto');

      removePaymentCatcher(elements);

      var warning = elements.datePicker
        ? elements.datePicker.querySelector(
            '.kaching-delivery-date-warning'
          )
        : null;

      if (warning) {
        warning.classList.remove('is-visible');
      }
    } else {
      /*
       * Keep the buttons grey, but allow the checkout
       * button to receive our intercepted click.
       */
      setImportantStyle(elements.checkout, 'opacity', '0.5');
      setImportantStyle(elements.checkout, 'pointer-events', 'auto');

      setImportantStyle(elements.payments, 'opacity', '0.5');
      setImportantStyle(elements.payments, 'pointer-events', 'auto');

      createPaymentCatcher(elements);
    }
  }

  function scheduleUpdate() {
    clearTimeout(updateTimer);

    updateTimer = window.setTimeout(function () {
      updateKachingCheckout();
    }, 50);
  }

  /*
   * Block the standard checkout button before Kaching
   * handles the click.
   */
  document.addEventListener(
    'click',
    function (event) {
      var checkout = event.target.closest(
        '#kaching-cart__checkout-button'
      );

      if (!checkout || hasDeliveryDate()) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      showWarning();
    },
    true
  );

  /*
   * Flare may fire input/change events or update its
   * data-delivery-date attribute.
   */
  document.addEventListener('input', function (event) {
    if (event.target.matches('#ship-date')) {
      scheduleUpdate();
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('#ship-date')) {
      scheduleUpdate();
    }
  });

  document.addEventListener('blur', function (event) {
    if (event.target.matches('#ship-date')) {
      scheduleUpdate();
    }
  }, true);

  var observer = new MutationObserver(function (mutations) {
    var relevantChange = mutations.some(function (mutation) {
      if (mutation.type === 'childList') {
        return mutation.addedNodes.length ||
          mutation.removedNodes.length;
      }

      return (
        mutation.type === 'attributes' &&
        mutation.target.matches &&
        mutation.target.matches('#ship-date')
      );
    });

    if (relevantChange) {
      scheduleUpdate();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [
      'value',
      'data-delivery-date'
    ]
  });

  /*
   * Kaching and Flare can rewrite inline styles after
   * rendering, so periodically confirm the correct state.
   */
  window.setInterval(function () {
    if (!document.hidden) {
      updateKachingCheckout();
    }
  }, 500);

  window.addEventListener('load', function () {
    window.setTimeout(updateKachingCheckout, 500);
  });

  updateKachingCheckout();
})();